// // images
// import blogImg1 from "../images/blog/img-1.jpg";
// import blogImg2 from "../images/blog/img-2.jpg";
// import blogImg3 from "../images/blog/img-3.jpg";

// import recent1 from "../images/recent-posts/img-1.jpg";
// import recent2 from "../images/recent-posts/img-2.jpg";
// import recent3 from "../images/recent-posts/img-3.jpg";


// import blogSingleImg1 from "../images/blog/1.jpg";
// import blogSingleImg2 from "../images/blog/2.jpg";
// import blogSingleImg3 from "../images/blog/3.jpg";



const blogs = [
   
   

];
export default blogs;